export const clearHTMLTags = ({ html }: { html: string }) => {
  return html.replaceAll(/<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g, '')
}
